import { parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js';

export interface NormalizeResult {
  e164: string;
  country: CountryCode;
}

export function normalizePhone(input: string, defaultCountry: CountryCode = 'US'): NormalizeResult | null {
  const parsed = parsePhoneNumberFromString(input, defaultCountry);
  // Use isPossible (length/format) rather than isValid (in-service prefix) so
  // Firebase fictional test numbers like +1 555-555-5555 pass through. Firebase
  // validates the actual number server-side.
  if (!parsed || !parsed.isPossible()) return null;
  return { e164: parsed.number, country: parsed.country || defaultCountry };
}

export function defaultCountryFromLocale(locale: string = navigator.language): CountryCode {
  // navigator.language values like "fr-FR", "en-US", "en-GB" — the region after
  // the dash maps directly to libphonenumber's CountryCode. Fall back to US.
  const region = locale.split('-')[1]?.toUpperCase();
  if (region && region.length === 2) return region as CountryCode;
  return 'US';
}
